import { parseAuthorId } from "~/utils/author";

import { createQueryMachine } from "../query.machine";

export const createPageAuthorQuery = (
	workspaceName: string,
	documentId: string,
	pageId: string,
	authorId: string
) => {
	return createQueryMachine({
		queryKey: ["page-author", workspaceName, documentId, pageId].join(":"),
		queryFn: async () => {
			const parsedAuthorInfo = parseAuthorId(authorId);
			if (!parsedAuthorInfo) {
				return null;
			}

			const { id, provider } = parsedAuthorInfo;

			switch (provider) {
				case "github": {
					const profile = await (await fetch(`https://api.github.com/user/${id}`)).json();
					const displayName = profile?.name;
					const githubUsername = profile?.login;
					const bio = profile?.bio;
					const profileImageFallback =
						typeof displayName === "string"
							? displayName
									.split(/\s/)
									.map((n) => n[0])
									.join("")
									.toUpperCase()
							: "?";

					return {
						provider,
						id,
						profileImageUrl: profile?.avatar_url,
						displayName,
						profileImageFallback,
						githubUsername,
						bio,
					};
				}
			}

			return null;
		},
	});
};
